// shell-context.ts — yhtenäisen kuoren konteksti (Johto-MEA U-3, 6.7.2026)
// OperatorShell asettaa true → kuoren SISÄLLÄ renderöityvät klassiset sivut
// piilottavat oman TopNavinsa (navigointi tulee kuoren alanavigoinnista).
// Tämä mahdollistaa KAIKKIEN klassisten sivujen tuonnin kuoreen kerralla;
// sivukohtainen MEA-tyylihionta jatkuu tämän päälle (U-jono).
import { createContext } from 'react';

export const ShellContext = createContext(false);
